import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import Table from '../table/Table';
import Quiz from '../quiz/Quiz';
import Word from '../word/Word';
import MatchingGaps from '../matching-gaps/MatchingGaps';

export default function Sett() {

   const location = useLocation();
   const [id, setId] = useState(new URLSearchParams(location.search).get('id'));
   const [data, setData] = useState([]);
   const [currentTask, setCurrentTask] = useState(0);
 
   const [finished, setFinished] = useState(0);

  useEffect(()=>{
   getData();
  },[id])

  useEffect(()=>{
   
   
  },[data])

   const getData = () => {
      axios.get("/appi/table/set/"+id, { withCredentials: true })
      .then(response => {
         console.log(response.data);
         setData(response.data);
      })
      .catch(error => {});
   }

   const handleNext =() =>{
      let num = currentTask;
      if((num+1) < data.length){
         setCurrentTask(num +1 );
      }
     
   }
   const handlePrev =() =>{
      let num = currentTask;
      if(num >0 ){
         
         setCurrentTask(num -1 );
      }
   }

  


  
  return (
    <div style={{width: '100%',minHeight:'100vh',display:'flex',flexDirection:'column', justifyContent:'center'}}>
     

      {
         Array.isArray(data) ?
         Object.values( data.map( (item, index) => (

            ( !(index === currentTask )) ? '':
            <div key={index} style={{width: '100%',minHeight:'100vh',display:'flex',flexDirection:'column', justifyContent:'center'}}>
               { 
                  ( !(item.grid.type === 1 )) ? '':
                    
                        <Table id={item.grid.id} />
                    
               }
               { 
                  ( !(item.grid.type === 2 )) ? '':
                     
                        <Quiz id={item.grid.id} />
                    
               }
               { 
                  ( !(item.grid.type === 3 )) ? '':
                     
                        <Word id={item.grid.id} />
                     
               }
               { 
                  ( !(item.grid.type === 4 )) ? '':
                    <div style={{width:'fit-content', marginInline:'auto'}}>
                      <MatchingGaps id={item.grid.id} />
                    </div> 
                       
                    
               }
            </div>
         ))) : ''
      }

     <div>
         <div className='set-btn-right' onClick={(e)=>handleNext()}>
            
         </div>
         <div className='set-btn-left' onClick={(e)=>handlePrev()}>
            
         </div>
      </div>
    </div>
  )
}
